import TrackingService from '../services/TrackingService';

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
const SELECTORS = {
    SERIES_DATA_VARIABLE: 'js_productSeriesData',
    PRODUCT_DETAIL_LINK: 'js-seriesDetailLink',
    PRODUCT_ADD_TO_CART_LINK: 'js-seriesAddToCart',
    ACCESSORY_ADD_TO_CART_LINK: 'js-seriesAddAccessory'
};

/**
 * 
 * @constructor
 */
export default class ProductSeriesView {
    constructor($element) {
        this.$element = $element;
        this.seriesData = window[SELECTORS.SERIES_DATA_VARIABLE];
        this.trackingService = new TrackingService();

        return this.createChildren()
                .setupHandlers()
                .trackItemListViewed();
    }

     createChildren() {
        this.$detailLinks = this.$element.find("." + SELECTORS.PRODUCT_DETAIL_LINK);
        this.$addToCartLinks = this.$element.find("." + SELECTORS.PRODUCT_ADD_TO_CART_LINK);
        this.$addAccessoryLinks = this.$element.find("." + SELECTORS.ACCESSORY_ADD_TO_CART_LINK);
        return this;
    }

    setupHandlers() {
        this.onDetailLinkClickedHandler = this.onDetailLinkClicked.bind(this);
        this.onAddToCartLinkClickedHandler = this.onAddToCartLinkClicked.bind(this);
        this.onAccessoryAddToCartLinkClickedHandler = this.onAccessoryAddToCartLinkClicked.bind(this);
        this.$detailLinks.on('click', this.onDetailLinkClickedHandler);
        this.$addToCartLinks.on('click', this.onAddToCartLinkClickedHandler);
        this.$addAccessoryLinks.on('click', this.onAccessoryAddToCartLinkClickedHandler);
        return this;
    }

    trackItemListViewed(){
        this.trackingService.viewItemList(this.seriesData.Name, this.seriesData.Title, this.seriesData.Products);
        return this;
    }

    onDetailLinkClicked(e) {
        let productCode = e.currentTarget.dataset.productCode;
        let seriesProduct = this.seriesData.Products.filter(function(p){
            return p.ProductCode == productCode;
        })[0];
        this.trackingService.selectItem(this.seriesData.Name, this.seriesData.Title, seriesProduct);
    }

    onAddToCartLinkClicked(e) {
        let productCode = e.currentTarget.dataset.productCode;
        let seriesProduct = this.seriesData.Products.filter(function(p){
            return p.ProductCode == productCode;
        })[0];
        seriesProduct.ProductQuantity = 1;
        this.trackingService.addToCart(seriesProduct);

        let diverterCheckbox = document.getElementById(productCode);
        if (diverterCheckbox != null && diverterCheckbox.checked) {
            let accessory = this.seriesData.DebrisDiverter;
            accessory.ProductQuantity = 1;
            this.trackingService.addToCart(accessory);
        }
    }

    onAccessoryAddToCartLinkClicked(e) {
        let accessory = this.seriesData.DebrisDiverter;
        accessory.ProductQuantity = 1;
        this.trackingService.addToCart(accessory);
    }

}